/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/hotels/reviews",
    },
    (router) => {
      router.push({
        id: "@api/hotel.review@create",
        path: "",
      });
      router.group(
        {
          path: "/:hotelReviewId",
        },
        (router) => {
          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api/hotel.review@customer-acknowledge",
                path: "/customer-acknowledge",
              });
            },
          );
        },
      );
    },
  );
}
